import { render } from "./recipient_picker.vue?vue&type=template&id=6e6b3cae"
import script from "./recipient_picker.vue?vue&type=script&lang=js"
export * from "./recipient_picker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__